import Vue from 'vue'
import consts from '@/consts'
import { createActionHelpers } from 'vuex-loading'
import i18n from '@/translator'

const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading'
})

const initialStates = function () {
  return {
    error: '',
    pricing: null
  }
}

const actions = {
  getPricing ({commit, dispatch}, value) {
    startLoading(dispatch, 'pricing getPricing')
    return new Promise((resolve, reject) => {
      Vue.http.get(consts.API_BASE_URL + '/pricings/getPricings').then(
        function (response) {
          endLoading(dispatch, 'pricing getPricing')
          if (response.body.status) {
            commit('setPricing', response.body.data)
            resolve(response.body.data)
          } else {
            commit('error', {error: true, message: i18n.t('error.store.tracks')})
            reject(new Error(i18n.t('error.store.network')))
          }
        },
        function () {
          endLoading(dispatch, 'pricing getPricing')
          commit('error', {error: true, message: i18n.t('error.store.network')})
          reject(new Error(i18n.t('error.store.network')))
        })
    })
  }
}

const mutations = {
  error (state, value) {
    state.error = value['message']
  },
  setPricing (state, value) {
    state.pricing = value
  }
}

const getters = {
  error: state => {
    return state.error
  },
  pricing: state => {
    return state.pricing
  }
}

const pricing = {
  namespaced: true,
  initialStates,
  state: initialStates(),
  mutations: mutations,
  actions: actions,
  getters: getters
}

export default pricing



// WEBPACK FOOTER //
// ./src/store/modules/pricing.js